/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { OrganizationStrictHttpResponse } from '../../organization-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ImportType } from '../../models/import-type';

export interface AdminImportLegacyDataPost$XWwwFormUrlencoded$Params {
  runCleanup?: boolean;
      body?: {
'ImportType'?: ImportType;
'CompanyName'?: string;
'UrnCompanyId'?: string;
'File'?: Blob;
}
}

export function adminImportLegacyDataPost$XWwwFormUrlencoded(http: HttpClient, rootUrl: string, params?: AdminImportLegacyDataPost$XWwwFormUrlencoded$Params, context?: HttpContext): Observable<OrganizationStrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, adminImportLegacyDataPost$XWwwFormUrlencoded.PATH, 'post');
  if (params) {
    rb.query('runCleanup', params.runCleanup, {});
    rb.body(params.body, 'application/x-www-form-urlencoded');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as OrganizationStrictHttpResponse<void>;
    })
  );
}

adminImportLegacyDataPost$XWwwFormUrlencoded.PATH = '/Admin/importLegacyData';
